/*
 * Runway Hair UK
 * ---------------------------------------------------------------------------
 * The product-page stock badge is now rendered server-side by the theme
 * (main-product > stock_status block). It is variant-aware, uses live
 * inventory, and states the correct dispatch time per colour.
 *
 * The old client-side badge that used to live in this file has been removed:
 * it duplicated that badge and quoted out-of-date dispatch times
 * (clip-ins as 5 days for every colour, Highlight Collection as 3 days).
 *
 * All that remains here is the cart-page note.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  function onCartPage() {
    return /(^|\/)cart(\/|$|\?)/.test(window.location.pathname + window.location.search);
  }

  function injectCartWarning() {
    if (document.getElementById('rw-cart-warning')) return;

    var anchor = document.querySelector('.cart__footer');
    if (!anchor) anchor = document.querySelector('[data-cart-footer]');
    if (!anchor) {
      var btn = document.querySelector('button[name="checkout"], input[name="checkout"]');
      if (btn) anchor = btn.closest('form') || btn.parentElement;
    }
    if (!anchor) return;

    var div = document.createElement('div');
    div.id = 'rw-cart-warning';
    div.innerHTML =
      '<p><strong>Before you check out:</strong> dispatch time is shown on each product page and is separate from delivery time. ' +
      'Anything in Jet Black, Light Ash Brown, Espresso Swirl or the Highlight Collection is made to order and dispatches within up to 10 working days.</p>' +
      '<p style="margin-top:8px"><strong>Please do not book your hair appointment until the hair is physically in your hands.</strong></p>';

    anchor.insertBefore(div, anchor.firstChild);
  }

  function init() {
    if (!onCartPage()) return;
    injectCartWarning();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
